import { PublicClientApplication, type Configuration } from "@azure/msal-browser";

const config: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID_PORTAL,
    authority: import.meta.env.VITE_AUTHORITY,
    redirectUri: import.meta.env.VITE_REDIRECT_URI,
    postLogoutRedirectUri: import.meta.env.VITE_REDIRECT_URI,
  },
  cache: { cacheLocation: "sessionStorage" },
};

export const msalInstance = new PublicClientApplication(config);

// Exporta o objeto de login (escopos)
export const loginRequest = {
  scopes: [import.meta.env.VITE_API_SCOPE!],
};

// Inicialização
export async function initMsal() {
  if (!(msalInstance as any)._isInitialized) {
    await msalInstance.initialize();

    const result = await msalInstance.handleRedirectPromise().catch((e) => {
      console.warn("MSAL redirect error:", e);
      return null;
    });

    if (result) {
      msalInstance.setActiveAccount(result.account);
    }

    (msalInstance as any)._isInitialized = true;
  }
}

